import {
  cloneDeep,
  difference,
  get,
} from 'lodash';

import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import getTotalPrice from 'client/Payments/utils/getTotalPrice';

export default {
  namespaced: true,
  state: {},
  actions: {},
  mutations: {},

  getters: {
    /**
    * Try to find a different combination of subscription + add-ons that has all the same features
    * for a lower price.
    * */
    betterValuePackage(state, getters, rootState, rootGetters) {
      const selectedPackage = rootGetters['CheckoutModel/item'];
      // Base package is always the best value
      if (!selectedPackage.addOns.length) return null;

      const patchAddOn = rootGetters['AddOnCollection/getItem']('PATCH-2021');
      const addOnsFlag = rootGetters['FeatureFlagsModule/betaFeatures'][featureFlags.purchaseAddOnsInProduct];
      const activeSubscriptions = rootGetters['SubscriptionCollection/getCollection'];
      const features = rootGetters['CheckoutModel/getAllFeatures'];
      const isAnnual = rootGetters['PricingModule/getIsAnnual'];
      const price = getTotalPrice(selectedPackage, isAnnual);

      let betterValuePackage = null;
      activeSubscriptions.forEach((subscription) => {
        // Cannot be better value than self
        if (subscription.productCode === selectedPackage.productCode) return;
        // Cannot be better value than smaller package
        if (subscription.features.length < selectedPackage.features.length) return;

        const equivalentPackage = cloneDeep(subscription);
        equivalentPackage.addOns = [];

        const missingFeatures = difference(
          features.map(feature => feature.name),
          subscription.features.map(feature => feature.name),
        );
        // Try to fill all missing features with add-ons
        if (missingFeatures.length) {
          const possibleAddOns = addOnsFlag ? subscription.optionalAddOns : [patchAddOn];
          const equivalentAddOns = possibleAddOns.filter((addOn) => {
            // Assume based on our current offerings that add-ons have one feature
            const [addOnFeature] = addOn.features;
            const indexOfAddOn = missingFeatures.indexOf(addOnFeature.name);
            const addOnContainsMissingFeature = indexOfAddOn >= 0;
            if (addOnContainsMissingFeature) {
              missingFeatures.splice(indexOfAddOn, 1); // Feature no longer missing
            }
            return addOnContainsMissingFeature;
          });
          equivalentPackage.addOns = equivalentAddOns;
        }
        const packageHasAllFeatures = missingFeatures.length === 0;

        equivalentPackage.savings = price - getTotalPrice(equivalentPackage, isAnnual);
        const packageHasLowerPrice = equivalentPackage.savings
          > get(betterValuePackage, 'savings', 0);

        if (packageHasAllFeatures && packageHasLowerPrice) {
          betterValuePackage = equivalentPackage;
        }
      });

      return betterValuePackage;
    },
  },
};
